import { isDemoMode } from "@/lib/demo/mode";

/**
 * Query-key builder for org-scoped data.
 *
 * Every query that reads organization data MUST build its key through this
 * helper so the key embeds the organization id — switching organizations then
 * resolves to different cache entries with no manual invalidation.
 *
 * The resource name stays FIRST so existing prefix invalidations like
 * `invalidateQueries({ queryKey: ["transactions"] })` keep working.
 */
export function orgScopedKey(resource: string, orgId: string, ...params: unknown[]) {
  // Sample data (src/lib/demo) gets its own cache entries, so the real
  // company's rows and the sample's can never be shown for each other.
  return [resource, isDemoMode() ? `demo:${orgId}` : orgId, ...params] as const;
}
